export enum EditorMode {
  Edit,
  Preview,
}
